import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const DeleteIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "delete",
  "DeleteIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M4.99967 0.666687H10.9997V3.00002H14.6663V4.33335H13.3131L12.9798 15.3334H3.01957L2.68624 4.33335H1.33301V3.00002H4.99967V0.666687ZM6.33301 3.00002H9.66634V2.00002H6.33301V3.00002ZM4.02018 4.33335L4.31311 14H11.6862L11.9792 4.33335H4.02018ZM8.66634 5.66669V12.6667H7.33301V5.66669H8.66634Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default DeleteIcon;
